'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'box-heart';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f49d';
var svgPathData = 'M432 148.5c0-1.5-.1-3-.2-4.5L16.2 144c-.1 1.5-.2 3-.2 4.5L16 416c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-267.5zM216 128l0-96-103.1 0c-15.5 0-30 7.5-39.1 20.1L24.9 120.6c-1.7 2.3-3.1 4.8-4.3 7.4L216 128zm211.4 0c-1.2-2.6-2.7-5-4.3-7.4L374.1 52.1c-9-12.6-23.6-20.1-39.1-20.1l-103.1 0 0 96 195.4 0zM0 148.5c0-13.3 4.2-26.3 11.9-37.2L60.9 42.8C72.9 26 92.3 16 112.9 16l222.1 0c20.7 0 40.1 10 52.1 26.8l48.9 68.5c7.8 10.9 11.9 23.9 11.9 37.2L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 148.5zM128 269.3l0 2.7c0 24.8 18.1 49.5 40.6 70.4 21.9 20.2 46.1 35.1 55.4 40.5 9.3-5.4 33.5-20.2 55.4-40.5 22.5-20.8 40.6-45.6 40.6-70.4l0-2.7c0-25-20.3-45.3-45.3-45.3-14.3 0-27.7 6.7-36.3 18.1l-8 10.7c-1.5 2-3.9 3.2-6.4 3.2s-4.9-1.2-6.4-3.2l-8-10.7c-8.6-11.4-22-18.1-36.3-18.1-25 0-45.3 20.3-45.3 45.3zM173.3 208c19.3 0 37.5 9.1 49.1 24.5l1.6 2.1 1.6-2.1c11.6-15.4 29.8-24.5 49.1-24.5 33.9 0 61.3 27.5 61.3 61.3l0 2.7c0 32-22.8 60.8-45.8 82.1-23.4 21.6-49.1 37.3-58.5 42.7-4.8 2.8-10.6 2.8-15.4 0-9.5-5.5-35.1-21.1-58.5-42.7-23-21.3-45.8-50.1-45.8-82.1l0-2.7c0-33.9 27.5-61.3 61.3-61.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoxHeart = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;